import { ClinicalTrialFormsManagementView } from 'src/pages/ClinicalTrial/ClinicalTrialForms/ClinicalTrialFormsManagement/ClinicalTrialFormsManagement.view';

export const ClinicalTrialFormsManagement = () => {
  return (
    <div>
      <ClinicalTrialFormsManagementView />
    </div>
  );
};
